import React from 'react';
import { Ship, Wrench, Clock, Bell } from 'lucide-react';
export const SpecializedServices = () => {
  const comingSoon = [{
    title: 'Import Duty Finance',
    description: 'Clear Your Vehicle Faster',
    details: 'Finance your import duty payments and get your vehicle released without delays',
    icon: <Ship size={32} className="text-gray-400" data-id="element-1138" />
  }, {
    title: 'Other Asset Finance',
    description: 'Custom Financing for Specialized Equipment',
    details: 'Tailored financing solutions for industrial equipment, machinery, and specialized assets',
    icon: <Wrench size={32} className="text-gray-400" data-id="element-1139" />
  }];
  return <section className="py-20 bg-gray-50" data-id="element-1140">
      <div className="container" data-id="element-1141">
        <div className="text-center mb-16" data-id="element-1142">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-1143">
            <Clock size={18} data-id="element-1144" />
            Coming Soon
          </div>
          <h2 className="section-title" data-id="element-1145">Future Solutions</h2>
          <p className="section-subtitle" data-id="element-1146">
            Expanding our offerings to serve you better. Stay tuned for these
            exciting new products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1147">
          {comingSoon.map((service, index) => <div key={index} className="relative bg-white rounded-2xl p-8 border-2 border-dashed border-gray-300 opacity-75" data-id="element-1148">
              {/* Coming Soon Badge */}
              <div className="absolute top-4 right-4 bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1" data-id="element-1149">
                <Bell size={14} data-id="element-1150" />
                Coming Soon
              </div>

              <div className="mb-4 w-16 h-16 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-1151">
                {service.icon}
              </div>

              <h3 className="text-2xl font-bold mb-2 text-gray-600" data-id="element-1152">
                {service.title}
              </h3>
              <p className="text-primary-600 font-semibold mb-3" data-id="element-1153">
                {service.description}
              </p>
              <p className="text-gray-500 text-sm mb-6" data-id="element-1154">{service.details}</p>

              <button disabled className="w-full py-3 px-6 bg-gray-200 text-gray-500 font-semibold rounded-lg cursor-not-allowed" data-id="element-1155">
                Notify Me When Available
              </button>
            </div>)}
        </div>
      </div>
    </section>;
};